/**
 * 코드 → 표시 텍스트 변환 헬퍼.
 *
 * 프로젝트 전반의 라벨 맵은 `Record<Union, string>`(예: `GRADE_LABEL`, `THEME_LABEL`, `UNIT_LABEL`) 형태로,
 * **키가 union 으로 좁혀져 있으면 `MAP[code]` 직접 인덱싱이 이미 타입 안전**하다 — 그때는 이 함수가 필요 없다.
 *
 * 이 함수는 **코드가 `string` 으로 흘러 들어올 때**를 위한 것이다(BE 응답 원문, URL 파라미터, 공통코드 등).
 * 그 경우 직접 인덱싱하면 타입은 `string` 이라고 우기는데 런타임엔 `undefined` 가 나와 화면이 빈칸이 된다
 * (실제로 `SUSPENDED` 가 union 에 없던 시절 그렇게 조용히 깨졌다). 여기서 폴백을 강제해 그 실패를 막는다.
 *
 * 기본 폴백은 **코드 원문** — 빈칸보다 `SUSPENDED` 라도 보이는 편이 원인 추적에 낫다.
 */
export function codeToText<K extends string>(
  map: Record<K, string>,
  code: string,
  fallback?: string,
): string {
  return (map as Record<string, string | undefined>)[code] ?? fallback ?? code;
}
